import React, {
  Fragment,
  useContext,
  useState,
} from "react";

import { Link } from "react-router-dom";

import { ThemeContext } from "../../../context/ThemeContext";

import profile from "../../../images/logo.png";
import logo from "../../../images/logomob.png";


const NavHader = () => {

  const [toggle, setToggle] = useState(false);

  const {
    navigationHader,
    openMenuToggle,
    background,
  } = useContext(ThemeContext);


  /* ============================================
     MENU TOGGLE
  ============================================ */

  const handleMenuToggle = () => {

    setToggle((previous) => !previous);

    if (typeof openMenuToggle === "function") {
      openMenuToggle();
    }

  };


  return (
    <>
      {/* =========================================
          CUSTOM RESPONSIVE STYLE
      ========================================== */}

      <style>{`

        /* ========================================
           DESKTOP
        ======================================== */

        .nav-header.rp-nav-header {
          position: relative;
        }


        .rp-desktop-logo {
          display: block;
          width: 63%;
          height: auto;
          object-fit: contain;
        }


        .rp-mobile-logo {
          display: none;
        }


        /* ========================================
           MOBILE / TABLET
        ======================================== */

        @media (max-width: 991px) {

          /*
           * Mobile logo completely hidden
           */

          .nav-header.rp-nav-header .brand-logo {
            display: none !important;
          }


          .nav-header.rp-nav-header .rp-desktop-logo,
          .nav-header.rp-nav-header .rp-mobile-logo {
            display: none !important;
          }


          /*
           * Nav header stays available
           * for hamburger button
           */

          .nav-header.rp-nav-header {
            position: absolute !important;

            left: 0 !important;
            top: 0 !important;

            width: 60px !important;
            min-width: 60px !important;

            height: 64px !important;
            min-height: 64px !important;

            padding: 0 !important;

            background: transparent !important;

            border: 0 !important;

            box-shadow: none !important;

            z-index: 9999 !important;
          }


          /* ======================================
             NAV CONTROL - LEFT SIDE
          ====================================== */

          .nav-header.rp-nav-header .nav-control {
            position: fixed !important;

            left: 12px !important;
            right: auto !important;

            top: 12px !important;

            width: 42px !important;
            height: 42px !important;

            margin: 0 !important;
            padding: 0 !important;

            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            border: 1px solid #e3ebe7 !important;
            border-radius: 12px !important;

            background: #ffffff !important;

            box-shadow:
              0 4px 14px
              rgba(19, 88, 70, 0.08) !important;

            transform: none !important;

            cursor: pointer;

            z-index: 99999 !important;
          }


          /*
           * Some template CSS can hide nav-control
           * after menu state changes.
           * Force it to remain visible.
           */

          #main-wrapper .nav-header.rp-nav-header .nav-control,
          #main-wrapper.menu-toggle .nav-header.rp-nav-header .nav-control {
            display: flex !important;

            left: 12px !important;
            right: auto !important;

            visibility: visible !important;
            opacity: 1 !important;
          }


          /* ======================================
             HAMBURGER
          ====================================== */

          .nav-header.rp-nav-header
          .nav-control
          .hamburger {
            width: 20px !important;
            height: 16px !important;

            display: flex !important;
            flex-direction: column;
            justify-content: space-between;

            padding: 0 !important;
            margin: 0 !important;
          }


          .nav-header.rp-nav-header
          .nav-control
          .hamburger
          .line {
            display: block !important;

            width: 20px !important;
            height: 2px !important;

            margin: 0 !important;

            border-radius: 20px;

            background: #135846 !important;

            transition:
              transform 0.25s ease,
              opacity 0.2s ease;
          }


          /* ACTIVE */

          .nav-header.rp-nav-header
          .nav-control
          .hamburger.is-active
          .line:nth-child(1) {
            transform:
              translateY(7px)
              rotate(45deg);
          }


          .nav-header.rp-nav-header
          .nav-control
          .hamburger.is-active
          .line:nth-child(2) {
            opacity: 0;
          }


          .nav-header.rp-nav-header
          .nav-control
          .hamburger.is-active
          .line:nth-child(3) {
            transform:
              translateY(-7px)
              rotate(-45deg);
          }

        }


        /* ========================================
           SMALL MOBILE
        ======================================== */

        @media (max-width: 575px) {

          .nav-header.rp-nav-header {
            width: 55px !important;
            min-width: 55px !important;

            height: 60px !important;
            min-height: 60px !important;
          }


          .nav-header.rp-nav-header .nav-control,
          #main-wrapper .nav-header.rp-nav-header .nav-control,
          #main-wrapper.menu-toggle .nav-header.rp-nav-header .nav-control {
            left: 9px !important;
            top: 10px !important;

            width: 40px !important;
            height: 40px !important;
          }

        }


        /* ========================================
           VERY SMALL MOBILE
        ======================================== */

        @media (max-width: 380px) {

          .nav-header.rp-nav-header .nav-control,
          #main-wrapper .nav-header.rp-nav-header .nav-control,
          #main-wrapper.menu-toggle .nav-header.rp-nav-header .nav-control {
            left: 8px !important;

            width: 38px !important;
            height: 38px !important;
          }


          .nav-header.rp-nav-header
          .nav-control
          .hamburger {
            width: 18px !important;
          }


          .nav-header.rp-nav-header
          .nav-control
          .hamburger
          .line {
            width: 18px !important;
          }

        }


        /* ========================================
           DESKTOP ONLY
        ======================================== */

        @media (min-width: 992px) {

          .nav-header.rp-nav-header .brand-logo {
            display: flex !important;
          }


          .rp-desktop-logo {
            display: block !important;
          }


          /*
           * Mobile logo never show
           */

          .rp-mobile-logo {
            display: none !important;
          }

        }

      `}</style>


      <div className="nav-header rp-nav-header">

        {/* =====================================
            LOGO
        ====================================== */}

        <Link
          to="/"
          className="brand-logo"
        >

          {background.value === "dark" ||
          navigationHader !== "color_1" ? (

            <Fragment>

              {/* DESKTOP LOGO */}

              <img
                className="rp-desktop-logo"
                src={profile}
                alt="Rajya Properties"
              />


              {/* MOBILE LOGO
                  Kept in JSX but hidden by CSS
              */}

              <img
                className="rp-mobile-logo"
                src={logo}
                alt="Rajya Properties"
              />

            </Fragment>

          ) : (

            <Fragment>

              {/* DESKTOP LOGO */}

              <img
                className="rp-desktop-logo"
                src={profile}
                alt="Rajya Properties"
              />


              {/* MOBILE LOGO
                  Kept in JSX but hidden by CSS
              */}

              <img
                className="rp-mobile-logo"
                src={logo}
                alt="Rajya Properties"
              />

            </Fragment>

          )}

        </Link>


        {/* =====================================
            NAV CONTROL
        ====================================== */}

        <div
          className="nav-control"
          role="button"
          tabIndex={0}
          onClick={handleMenuToggle}
          onKeyDown={(e) => {

            if (
              e.key === "Enter" ||
              e.key === " "
            ) {

              e.preventDefault();

              handleMenuToggle();

            }

          }}
        >

          <div
            className={`hamburger`}
          >

            <span className="line"></span>

            <span className="line"></span>

            <span className="line"></span>

          </div>

        </div>

      </div>
    </>
  );
};


export default NavHader;